<template>
  <span class="arrow-icon">
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M10.2803 3.96967C10.5732 4.26256 10.5732 4.73744 10.2803 5.03033L7.31066 8L10.2803 10.9697C10.5732 11.2626 10.5732 11.7374 10.2803 12.0303C9.98744 12.3232 9.51256 12.3232 9.21967 12.0303L5.71967 8.53033C5.42678 8.23744 5.42678 7.76256 5.71967 7.46967L9.21967 3.96967C9.51256 3.67678 9.98744 3.67678 10.2803 3.96967Z" fill="#667488" />
    </svg>
  </span>
</template>
<script type="text/ecmascript-6" src="./scripts/index.js"></script>
<style>
    .arrow-icon{
        height: 1.5rem;
        border: 1px solid #DBDFE5;
        border-radius: 50%;
        width: 1.5rem;
        display: flex;
        justify-content: center;
        align-items: center;
        background: #FFFFFF;
    }
    .arrow-icon:hover{
        background: #1A73E8;
        border: 1px solid #1A73E8;
        cursor: pointer;
    }
     .arrow-icon:hover svg path {
        fill: #FFFFFF;
    }
</style>